module.exports = __webpack_public_path__ + "res/Roboto-BoldItalic-webfont.ttf?0cb341a3d9971a82cbabca5497d2f579";


//////////////////
// WEBPACK FOOTER
// ./assets/fonts/roboto/Roboto-BoldItalic-webfont.ttf
// module id = 34
// module chunks = 0